import styles from "../../styles/components/AdminDetailModals.module.css";
import Toggle from "../../ui/selectors/Toggle";

export const ASSIGNMENT_FLAGS = [
  { field: "is_mail_account_admin", label: "Admin" },
  { field: "can_send", label: "Enviar" },
  { field: "can_receive", label: "Recibir" },
];

export const EMPTY_ASSIGNMENT_DRAFT = {
  userId: "",
  is_mail_account_admin: false,
  can_send: true,
  can_receive: true,
};

export default function MailAccountAssignmentFlags({ values, onToggle, disabled = false, labelSuffix }) {
  return (
    <div className={styles.mailUserFlags}>
      {ASSIGNMENT_FLAGS.map(({ field, label }) => (
        <div key={field} className={styles.flagItem}>
          <span className={styles.flagLabel}>{label}</span>
          <Toggle
            checked={Boolean(values[field])}
            onChange={() => onToggle(field)}
            disabled={disabled}
            ariaLabel={`${label} ${labelSuffix}`}
          />
        </div>
      ))}
    </div>
  );
}
